import {
  DeliveryDto,
  DeliveryPageDto,
} from "../../../types/delivery/delivery-dto";
import { convertDeliveryDtoToDelivery } from "../../../utils/converter/delivery/delivery-converter";
import { DeliveryState } from "../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveryPageDto: DeliveryPageDto;
  };
}

export const setDeliveryPageDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveryPageDto } = action.payload;
  state.deliveryPage = {
    contents: deliveryPageDto.contents.map((deliveryDto: DeliveryDto) => {
      return convertDeliveryDtoToDelivery(deliveryDto);
    }),
    first: deliveryPageDto.first,
    last: deliveryPageDto.last,
    page: deliveryPageDto.page,
    totalPages: deliveryPageDto.totalPages,
    totalElements: deliveryPageDto.totalElements,
  };
};
